module.exports = __webpack_public_path__ + "static/media/calendar.dd080582.svg";